import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import JsonLd, { careerDesignCenterPageMeta, careerDesignCenterSchema } from 'components/common/schema'
import Template from 'components/cases/career-design-center'

const CareerDesignCenter: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.add('non-chat')
  }, [])
  return (
    <>
      <HeadMeta {...careerDesignCenterPageMeta} />
      <JsonLd data={careerDesignCenterSchema} />
      <Template />
    </>
  )
}

export default CareerDesignCenter
